<template>
    <b-col cols="auto" class="form-inline pt-3">
        <b-form-group class="mr-sm-2"
                      :label="label"
                      label-for="search-field">
            <b-form-input v-model.trim="search"
                          id="search-field"
                          class="text-left ml-2 w-100"
                          @input="searchAction"
                          placeholder="Write something..."></b-form-input>
        </b-form-group>

        <button class="btn btn-close text-red" @click="resetInput">&times;</button>
    </b-col>
</template>

<script>
    import { inputTypeTimer } from '@/utils'
    export default {
        name: 'SearchField',
        props: {
            label: {
                type: String,
                default: 'Search:'
            },
        },
        data() {
            return {
                timeOut: null,
                search: this.$route.query.search ? this.$route.query.search : '',
            }
        },
        created() {
            this.searchAction = inputTypeTimer(this.searchAction, this.timeOut, 700)
        },
        methods: {
            searchAction() {
                this.$emit('searchValue', this.search)
            },
            resetInput() {
                if (this.search !== '') {
                    this.search = ''
                    this.$emit('searchValue', this.search)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/SearchField.vue